global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');

require('jquery-ui/1.12.1/jquery-ui.min');
//require('jquery-ui-dist/jquery-ui.min');
require('jquery-ui-multidatespicker/jquery-ui.multidatespicker');
require('jquery-ui/ui/i18n/datepicker-ko');

require('cleave.js');
global.moment = require('moment');

require('bootstrap');
require('bootstrap-select');

require('bootstrap-tagsinput');

require('summernote/dist/summernote-bs4.min');
require('summernote/dist/lang/summernote-ko-KR');
require('./summernote.setting');

require('./font-awesome-5-11-2');

require('fullcalendar/main');
require('fullcalendar/locales/ko');

require('./ready');
require('./common');
require('./modal');

require('./route_locals');
require('./route_dests');
require('./route_hotels');
require('./route_airport');